import React from "react";

import {
  UilTemperature,
  UilTear,
  UilWind,
  UilSun,
  UilSunset,
} from "@iconscout/react-unicons";
import { formatToLocalTime, iconUrlFromCode } from "../Services/WeatherService";

const TemperatureDetails = ({
  weather: {
    details,
    icon,
    temp,
    temp_min,
    temp_max,
    sunrise,
    sunset,
    speed,
    humidity,
    feels_like,
    timezone,
  },
  unit,
}) => {
  let DisplayUnit = unit === "imperial" ? "F" : "C";
  return (
    <div>
      <div className="flex flex-col md:flex-row items-center justify-center py-6 text-xl text-cyan-300">
        <p>{details}</p>
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between text-white py-3">
        <img src={iconUrlFromCode(icon)} alt="no-sun" className="w-30 h-30 " />
        <p className="text-4xl transition-all ease-in-out">
          {temp.toFixed(1)}° {DisplayUnit}
        </p>
        <div className="flex flex-col space-y-2 ">
          <div className="flex font-light text-sm items-center justify-center mt-8 md:mt-0">
            <UilTemperature size={18} className="md:mx-1" />
            Real fell :<span className="font-medium mx-1 ">{feels_like}°</span>
          </div>

          <div className="flex font-light text-sm items-center justify-center">
            <UilTear size={18} className="mx-1" />
            Humidity :<span className="font-medium mx-1">{humidity}%</span>
          </div>

          <div className="flex font-light text-sm items-center justify-center">
            <UilWind size={18} className="mx-1" />
            Wind :<span className="font-medium mx-1">{speed} Km/h</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2 md:gap-0 md:flex-row items-center justify-between space-x-1 text-white text-sm py-3">
        <UilSun />
        <p className="font-light">
          Rise :{" "}
          <span className="font-medium ml-1">
            {formatToLocalTime(sunrise, timezone, "hh:mm a")}
          </span>
        </p>

        <p className="font-light">|</p>

        <UilSunset />
        <p className="font-light">
          Set :{" "}
          <span className="font-medium ml-1">
            {formatToLocalTime(sunset, timezone, "hh:mm a")}
          </span>
        </p>

        <p className="font-light">|</p>

        <UilSun />
        <p className="font-light">
          High :{" "}
          <span className="font-medium ml-1">{temp_max.toFixed(2)}°</span>
        </p>

        <p className="font-light">|</p>

        <UilSun />
        <p className="font-light">
          {/* subtracting 4.0 degrees because api providing same temp as min and max time , its API's bug , in order for it to looks more close to reality , I sub from it */}{" "}
          Low :{" "}
          <span className="font-medium ml-1">
            {(temp_min - 4.0).toFixed(2)}°
          </span>
        </p>
      </div>
    </div>
  );
};

export default TemperatureDetails;
